// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"49f53ac0","160":"3be9d340","208":"b19f1a9c","293":"df75da92","453":"4a2cf735","516":"df030331","519":"63a89a28","917":"aa2fc8c2","946":"b3932ebe"}[chunkId] + ".chunk.js";
};